import React from "react";
import { useSelector } from "react-redux";
import { LanguageLoader } from '../../../assets/languages/index.js';
import Attachments from "../../../components/features/Attachments.jsx";
import Addresses from "../../../components/features/Addresses.jsx";
import Phone from "../../../components/features/Phone.jsx";
import Select from 'react-select';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from "../../../services/axios.js";
import { config } from "../../../services/config.js";
import { Toastify } from '../../../components/utils/index.js';
import Modal from '../../../components/features/Modal.jsx';
import DatePicker from "react-multi-date-picker";
import persian_fa from "react-date-object/locales/persian_fa";
import persian from "react-date-object/calendars/persian";
import DateObject from "react-date-object";
import { DownloadByContent } from "../../../components/utils/index.js";
import { DownloadFileAPI } from "../../../services";

const CreateWork_Orders = () => {
	const preferences = useSelector((state) => state.preferences);
	const [workType, setWorkTypesOptions] = useState([]);
	const [selectedWorkType, setSelectedWorkType] = useState('');
	const [serviceEmployee, setServiceEmployeeOptions] = useState([]);
	const [selectedServiceEmployee, setSelectedServiceEmployee] = useState('');
	const [assetSerialNumber, SetAssetSerialNumber] = useState('');
	const [assetAccountID, SetAssetAccountID] = useState('');
	const [assetRefrenceNumber, SetAssetRefrenceNumber] = useState('');
	const [account, SetAccount] = useState('');
	const language = LanguageLoader(preferences.language);
	const [addresses, SetAddress] = useState('');
	const [dataEntry, SetDataEntry] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [showAosProductModal, setAosProductModal] = useState(false);
	const [hideModal, setFallDownModal] = useState(false);
	const [hideAosProductModal, setAosProductFallDownModal] = useState(false);
	const [phoneNumber, setPhoneNumber] = useState('');
	const [nationalNumber, SetNationalNumber] = useState('');
	const [notFoundEntry, SetNotFoundEntry] = useState(false);
	const [warranty, SetWarranty] = useState();
	const [warrantyDetails, setWarrantyDetails] = useState(null);
	const [showWarrantyDetailsModal, setShowWarrantyDetailsModal] = useState(false);
	const [serviceMethod, SetServiceMethod] = useState("Guarantee");
	const navigate = useNavigate();
	const [attachments, SetAttachment] = useState([]);
	const [description, SetDescription] = useState();
	const [date, SetDate] = useState();
	const [searched,setSearchStatus] = useState(false);
	const [status, SetStatus] = useState("In_Progress");
	const [originalStatus, setOriginalStatus] = useState('');
	const [workOrderId, SetWorkOrderId] = useState();
	const [assetLocation, setSelectAssetLocation] = useState(null);
	const [aosProductSearch, SetAosProductSearch] = useState(null);
	const [aosProductSearchResult, SetaosProductSearchResult] = useState();
	const [selectedParts, setSelectedParts] = useState([]);
	const [deletedParts, setDeletedParts] = useState([]);
	const [showPartsTable, setShowPartsTable] = useState(false);
	const [searchParams] = useSearchParams();
	// Add state for selected record index
	const [selectedDataEntryIndex, setSelectedDataEntryIndex] = useState(0);
	const [typingTimeout, setTypingTimeout] = useState(null);
	const [pendingPhoneSelect, setPendingPhoneSelect] = useState(false);
	const [addressKey, setAddressKey] = useState(0);
	const [hasInstallationWorkOrder, setHasInstallationWorkOrder] = useState(false);
	const [workOrderNumber, setWorkOrderNumber] = useState('');

	const id = searchParams.get("id");
	useEffect(() => {
		if (id){
			FetchWorkOrderById(id);
		}
	}, [searchParams]);

	const FetchWorkOrderById = async (id) =>{
		try{
			const method = 'FetchWorkOrderById';
			const data = {
				workOrderId:id,
			};
			const APIResponse = await api.post(
				config.api + '?method=' + method,
				JSON.stringify(data)
			);
			const resp = APIResponse?.data || APIResponse;
			if (resp) {
				SetWorkOrderId(resp.workOrderId || undefined);
				SetAssetSerialNumber(resp.assetSerialNumber || '');
				SetAssetRefrenceNumber(resp.assetRefrenceNumber || '');
				SetStatus(resp.status || 'In_Progress');
				setOriginalStatus(resp.status || 'In_Progress');
				SetDescription(resp.description || '');
				SetServiceMethod(resp.serviceMethod || 'Guarantee');
				setWorkOrderNumber(resp.number || '');
				if (resp.date) {
					try {
						const normalized = String(resp.date).replaceAll('-', '/');
						SetDate(normalized);
					} catch {}
				}
				// Selects expect ids
				if (resp.workType && resp.workType.value) {
					setSelectedWorkType(resp.workType.value);
				}
				if (resp.serviceEmployee && resp.serviceEmployee.value) {
					setSelectedServiceEmployee(resp.serviceEmployee.value);
				}
				if (resp.account) {
					SetAccount(resp.account);
				}
				setDisabledFields(prev => ({
					...prev,
					warranty: resp?.warranty?.warranty_status_key === 'Under_Warranty',
					assetSerialNumber: true,
					assetRefrenceNumber: true
				}));
				// Store warranty details for the modal when editing
				if (resp?.warranty && resp?.warranty?.has_warranty) {
					setWarrantyDetails(resp.warranty);
				}
				if (Array.isArray(resp.addresses)) {
					SetAddress([...resp.addresses]);
					SetDataEntry([{ id: resp.id, name: resp.account, addresses: resp.addresses }]);
				} else {
					SetDataEntry([{ id: resp.id, name: resp.account }]);
				}
				if (resp.assetLocation) {
					setSelectAssetLocation(resp.assetLocation);
				}
				if (Array.isArray(resp.selectedParts)) {
					setSelectedParts(resp.selectedParts.map(p => ({ ...p, count: p.count || p.qty_required || 1, checked: p.under_warranty === "1", isExisting: true })));
					setShowPartsTable(resp.selectedParts.length > 0);
				}
				if(Array.isArray(resp.attachments)){
					SetAttachment(resp.attachments);
				}
				if (resp?.relatedProducts) {
					SetaosProductSearchResult(resp.relatedProducts);
				}
				if (resp.warranty && resp.warranty.has_warranty) {
					setWarrantyDetails(resp.warranty);
				}
			}
		}catch{

		}
	}

	const DoSave = async (saveType) => 
	{
		if (assetAccountID && dataEntry?.[0]?.id !== assetAccountID)
		{
			Toastify("حساب انتخاب شده با حساب دستگاه همخوانی ندارد");
			return;
		}
		if(attachmentRequireCondition)
		{
			if (!attachments || attachments.length === 0)
			{
				Toastify("با شرایط انتخاب شده فایل ضمیمه اجباری است");
				return;
			}
		}
		if (!dataEntry?.[0]?.id)
		{
			Toastify("حساب انتخاب نشده است");
			return;
		}
		if (!assetSerialNumber)
		{
			Toastify("شماره سریال دستگاه الزامی است");
			return;
		}
		if (selectedOption?.operation_type === "installation") 
		{
			if (!assetRefrenceNumber || assetRefrenceNumber.trim().length !== 13) 
			{
				Toastify("شماره رهگیری الزامی و باید 13 رقم باشد");
				return;
			}
		}
		if (assetRefrenceNumber && assetRefrenceNumber.trim().length !== 13) 
		{
			Toastify("کد رهگیری باید 13 رقم باشد");
			return;
		}
		if(!date || date.length === 0)
		{
			Toastify("تاریخ انجام کار الزامی است");
			return;
		}
		// Check if selected parts are required for field_service/installation work types with Guarantee service method
		if (selectedOption?.operation_type && ['field_service', 'installation'].includes(selectedOption.operation_type) && serviceMethod === 'Guarantee')
		{
			// Skip validation if without_service_invoice is 1
			if (selectedOption.without_service_invoice !== "1") {
				const activeParts = selectedParts.filter(p => !p.isDeleted);
				if (!activeParts || activeParts.length === 0)
				{
					Toastify("برای نوع کار انتخاب شده، انتخاب حداقل یک اجرت و قطعه الزامی است");
					return;
				}
			}
		}
		let parsedDateObject;
		if (typeof date === "string") 
		{
			const englishDateString = convertPersianToEnglishDigits(date);
			try 
			{
				parsedDateObject = new DateObject({
				date: englishDateString,
				format: "YYYY/MM/DD",
				calendar: persian,
				});
			} 
			catch (e) 
			{
				Toastify("تاریخ وارد شده معتبر نیست");
				return;
			}
		}
		else if (typeof date.toDate === "function") 
		{
			parsedDateObject = date;
		}
		else
		{
			Toastify("فرمت تاریخ نامعتبر است");
			return;
		}
		const selectedJSDate = parsedDateObject.toDate();
		const today = new Date();
		const oneMonthAgo = new Date();
		oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
		if (selectedJSDate > today) 
		{
			Toastify("تاریخ نمی‌تواند در آینده باشد");
			return;
		}
		if (selectedJSDate < oneMonthAgo) 
		{
			Toastify("تاریخ نمی‌تواند بیشتر از یک ماه قبل باشد");
			return;
		}
		let finalAddresses = addresses;
		if (dataEntry?.[0]?.id) 
		{
			finalAddresses = addresses.filter(
				(address) => !address.id || address.id.trim() === ""
			);
		}
		const data = {
			id: dataEntry?.[0]?.id || undefined,
			workOrderId: workOrderId,
			workType: selectedOption,
			serviceEmployee: selectedServiceEmployeeOption,
			assetRefrenceNumber: assetRefrenceNumber,
			assetSerialNumber: assetSerialNumber,
			account: account,
			status: status,
			serviceMethod: serviceMethod,
			description: description,
			addresses: finalAddresses,
			date: parsedDateObject.format("YYYY/MM/DD"),
			assetLocation : assetLocation,
			selectedParts: selectedParts.filter(p => !p.isDeleted),
			deletedParts: deletedParts,
			attachments: attachments
		};
		const method = "SaveNewWorkorder";
		const APIResponse = await api.post(
		config.api + "?method=" + method,
		JSON.stringify(data)
		);

		if (APIResponse.result == true && saveType === 'productRequest')
		{
			navigate(`/dynamic/CreateProduct_Request?workorder_id=${APIResponse.id}`);
		}
		else if (APIResponse.result == true)
		{
			navigate(`/detail/Work_Orders/${APIResponse.id}`);
		}
	};

	const handleSearchAosProduct = async (ProductListSearch)=>
	{
		if(ProductListSearch.length < 3)
		{
			return;
		}
		const data = {
			ProductListSearch: ProductListSearch,
			assetId: dataEntry[0]?.assetId ?? null,
			workType: selectedOption,
			assetSerialNumber: assetSerialNumber,
		};
		const method = 'ProductList';
		const APIResponse = await api.post(
			config.api + '?method=' + method,
			JSON.stringify(data)
		);
		SetaosProductSearchResult(APIResponse.data);
	}

	const handleLiveSearch = (value) => {
		SetAosProductSearch(value);
		if (typingTimeout) {
			clearTimeout(typingTimeout);
		}
		if (value && value.length > 3) {
			const timeout = setTimeout(() => {
				handleSearchAosProduct(value);
			}, 300);
			setTypingTimeout(timeout);
		}
	}

	function convertPersianToEnglishDigits(str) {
		return str.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
	}
	const [disabledFields, setDisabledFields] = useState({
		assetRefrenceNumber: false,
		account: false,
		assetSerialNumber: false,
	});

	const handleSerialNumber = async (serialNumber) => {
		if(!serialNumber || serialNumber.length === 0)
		{
			return;
		}
		const data = {
			serial_number: serialNumber
		};
		const method = 'checkSerialNumber';
		const APIResponse = await api.post(
			config.api + '?method=' + method,
			JSON.stringify(data)
		);

		if (APIResponse.NotExist === true) 
		{
			SetAssetSerialNumber('');
			Toastify('دستگاهی با شماره سریال وارد شده یافت نشد');
			return;
		}
		if (APIResponse.data.workOrderId && APIResponse.data.workOrderId.length > 0)
		{
			// SetWorkOrderId(APIResponse.data.workOrderId);
			Toastify('امکان انتخاب نوع کار نصب و راه اندازی وجود ندارد');
			// SetAssetSerialNumber('');
			setHasInstallationWorkOrder(true);
			// return;
		}
		if (APIResponse.result === true)
		{
			const fetchedData = APIResponse.data;
			SetAssetAccountID(fetchedData.asset_account_id);
			if(searched == false)
			{
				SetAccount(fetchedData.accountName);
				SetDataEntry([fetchedData]);
			}
			// Automatically fill addresses for reference number search
			if (fetchedData.addresses) {
				SetAddress([...fetchedData.addresses]);
				// Set assetLocation to the first address if available
				if (fetchedData.addresses.length > 0) {
					setSelectAssetLocation(fetchedData.addresses[0]);
				} else {
					setSelectAssetLocation(null);
				}
			}
			SetAssetRefrenceNumber(fetchedData.referenceNumber);
			setDisabledFields({
				...disabledFields,
				assetRefrenceNumber: fetchedData.referenceNumber !== '',
				warranty: fetchedData.warranty.warranty_status_key === 'Under_Warranty'
			});
			// Store warranty details for the modal
			if (fetchedData.warranty && fetchedData.warranty.has_warranty) {
				setWarrantyDetails(fetchedData.warranty);
			}
			if (fetchedData?.relatedProducts) {
				SetaosProductSearchResult(fetchedData.relatedProducts);
			}
		}
	};

	const HandleAttachment = (value) => {
		SetAttachment(value);
	};

	const handleSearchByPhone = async (phoneNumber) => {
		SetNotFoundEntry(false);
		if(phoneNumber.length === 0) {
			/* same as national number */
			if (!account || account.length === 0) {
				SetDataEntry([]);
			}
			return;
		}
		SetNationalNumber('');
		const data = {
			phoneNumber: phoneNumber
		};
		const method = 'DuplicatePhoneNumber';
		const APIResponse = await api.post(
			config.api + '?method=' + method,
			JSON.stringify(data)
		);
		if (APIResponse.result == true) {
			// Handle both array and object responses
			if (Array.isArray(APIResponse.data)) {
				SetDataEntry(APIResponse.data);
			} else if (APIResponse.data && typeof APIResponse.data === 'object') {
				SetDataEntry([APIResponse.data]);
			} else {
				SetDataEntry([]);
			}
		}
		else {
			SetNotFoundEntry(true);
		}
		return;
	}

	const CalculatePolicies = async () => {
		const activeParts = selectedParts.filter(p => !p.isDeleted);
		if (!dataEntry?.[0]?.id)
		{
			Toastify("حساب انتخاب نشده است");
			return;
		}
		if (!date || date.length === 0)
		{
			Toastify("تاریخ انجام کار الزامی است");
			return;
		}
		if (!activeParts.length)
		{
			Toastify("انتخاب حداقل یک اجرت و قطعه الزامی است");
			return;
		}
		const data = {
			account_id: dataEntry[0].id,
			date: typeof date === "string" ? convertPersianToEnglishDigits(date) : date,
			lineItems: activeParts.map(part => ({
				id: part.product_id || part.id,
				count: part.count || 1,
			})),
			ModuleName: "Work_Orders",
			workOrderId: workOrderId,
		};
		const method = "getCalculatePoliciesRahkaran";
		const APIResponse = await api.post(
			config.api + "?method=" + method,
			JSON.stringify(data)
		);
		if (!APIResponse)
		{
			Toastify("خطا در برآورد قیمت");
			return;
		}
		const policyError = APIResponse?.Partner?.error || APIResponse?.ServiceInvoice?.error;
		if (APIResponse?.Partner?.success === false && APIResponse?.ServiceInvoice?.success === false)
		{
			Toastify(typeof policyError === "string" && policyError ? policyError : "خطا در برآورد قیمت");
			return;
		}
		const partnerItems = APIResponse?.Partner?.items || {};
		const invoiceItems = APIResponse?.ServiceInvoice?.items || {};
		setSelectedParts(prev => prev.map(part => {
			const asId = part.id_AS;
			return {
				...part,
				consumerPrice: getPolicyPrice(invoiceItems, asId) ?? part.consumerPrice,
				partnerPrice: getPolicyPrice(partnerItems, asId) ?? part.partnerPrice,
			};
		}));
	}

	const getPolicyPrice = (items, asId) => {
		if (!items || asId === undefined || asId === null || asId === '')
		{
			return undefined;
		}
		const matched = items[asId] ?? items[String(asId)];
		if (matched)
		{
			return matched.price ?? matched.netPrice;
		}
		const key = Object.keys(items).find(k => String(k) === String(asId));
		if (!key)
		{
			return undefined;
		}
		return items[key].price ?? items[key].netPrice;
	}

	const formatPrice = (value) => {
		if (value === undefined || value === null || value === '')
		{
			return '';
		}
		const num = Number(value);
		if (Number.isNaN(num))
		{
			return value;
		}
		return num.toLocaleString('fa-IR');
	}

	const handleSelectAddress = (selectedOption) => {
		// Find address by id or by index for temp addresses
		const selectedAddrObj = addresses.find(addr => {
			if (addr.id === selectedOption.value) return true;
			if (selectedOption.value.startsWith('temp-')) {
				const index = parseInt(selectedOption.value.split('-')[1]);
				return addresses.indexOf(addr) === index;
			}
			return false;
		});
		setSelectAssetLocation(selectedAddrObj);
	};

	const handleSearchByNationalNumber = async (nationalNumber) => {
		SetNotFoundEntry(false);
		if(nationalNumber.length === 0)
		{
			// Only clear dataEntry if no account is selected (it's just search results)
			// If account is selected, preserve dataEntry for save validation
			if (!account || account.length === 0) {
				SetDataEntry([]);
			}
			return;
		}
		if(nationalNumber.length < 10)
		{
			Toastify('کد ملی وارد شده صحیح نیست');
			return;
		}
		setPhoneNumber('');
		const data = {
			nationalCode: nationalNumber
		};
		const method = 'DuplicateNationalCode';
		const APIResponse = await api.post(
			config.api + '?method=' + method,
			JSON.stringify(data)
		);
		if (APIResponse.result == true) {
			SetDataEntry([APIResponse.data]);
			SetNotFoundEntry(false);
		}
		else {
			SetNotFoundEntry(true);
		}
		return;
	}

	const FillInputes = async (index) => {
		setSearchStatus(true);
		setFallDownModal(true);
		// Reorder so the selected record becomes the first element; ensures dataEntry[0].id exists
		if (Array.isArray(dataEntry) && dataEntry[index]) {
			const selectedRecord = dataEntry[index];
			const reordered = [selectedRecord, ...dataEntry.filter((_, i) => i !== index)];
			SetDataEntry(reordered);
			setSelectedDataEntryIndex(0);
			if (selectedRecord?.name) {
				SetAccount(selectedRecord.name);
			}
			if (selectedRecord?.addresses) {
				SetAddress([...selectedRecord.addresses]);
				// Set assetLocation to the first address if available
				if (selectedRecord.addresses.length > 0) {
					setSelectAssetLocation(selectedRecord.addresses[0]);
				} else {
					setSelectAssetLocation(null);
				}
			}
		}
	};
	
	const selectPartAos = async (index) => {
		const selectedItem = aosProductSearchResult[index];
		setSelectedParts(prev => {
			const exists = prev.some(p => p.id === selectedItem.id);
			if (!exists) {
				setShowPartsTable(true);
				// Add default values: count: 1, checked: true, mark as new in edit mode
				return [...prev, { ...selectedItem, count: 1, checked: true, isExisting: false }];
			}
			return prev;
		});
	};

	const HandleAddress = (value) => {
		SetAddress(value);
	};

	const handleWorkTypeChange = (selectedOption) => {
		// Check if there's an installation work order and user is trying to select installation type
		if (hasInstallationWorkOrder && selectedOption.operation_type === 'installation') {
			Toastify('نمی‌توانید نوع کار نصب را انتخاب کنید زیرا این دستگاه قبلاً در دستور کار دیگری ثبت شده است');
			return;
		}
		setSelectedWorkType(selectedOption.value);
		
		// Auto-set service method to گارانتی and check warranty for installation work type
		if (selectedOption.operation_type === 'installation') {
			SetServiceMethod('Guarantee');
			// Auto-check warranty for all selected parts
			setSelectedParts(prev =>
				prev.map(p => ({ ...p, checked: true }))
			);
		}
	};

	const handleDuplicateRefrenceNumber =async (value) => {
		if(id) // this is in edit mode
		{
			return;
		}
		if(assetRefrenceNumber.length === 0)
		{
			return;
		}
		const data = {
			assetRefrenceNumber: assetRefrenceNumber
		};
		const method = 'duplicateReferenceNumber';
		const APIResponse = await api.post(
			config.api + '?method=' + method,
			JSON.stringify(data)
		);
		if(APIResponse && APIResponse.NotExist === false)
		{
			Toastify('شماره مرجع دستگاه باید یکتا باشد');
			SetAssetRefrenceNumber('');
			return;
		}
	};

	const newCustomer = () => {
		const serialParam = assetSerialNumber ? `&serial=${encodeURIComponent(assetSerialNumber)}` : '';
		window.location.href = `/dynamic/CreateAccounts?BackTo=CreateWork_Orders${serialParam}`;
	}

	useEffect(() => {
		const serial = searchParams.get('serial');
		if (serial && serial.length) {
			SetAssetSerialNumber(serial);
			handleSerialNumber(serial);
		}
		const phoneParam = searchParams.get('phone');
		if (phoneParam && phoneParam.length) {
			setPhoneNumber(phoneParam);
			setPendingPhoneSelect(true);
			handleSearchByPhone(phoneParam);
		}
	}, []);

	useEffect(() => {
		if (!pendingPhoneSelect) return;
		if (Array.isArray(dataEntry)) {
			if (dataEntry.length === 1) {
				FillInputes(0);
				setShowModal(false);
				setPendingPhoneSelect(false);
			} else if (dataEntry.length > 1) {
				setShowModal(true);
				setPendingPhoneSelect(false);
			}
		}
	}, [dataEntry, pendingPhoneSelect]);

	// Clear warranty values when switching to Non_Guarantee (both create and edit mode)
	useEffect(() => {
		if (serviceMethod === 'Non_Guarantee') {
			// Clear selected parts warranty only
			setSelectedParts(prev =>
				prev.map(p => ({ ...p, checked: false }))
			);
		}
	}, [serviceMethod]);

	useEffect(() => {
		const fetchWorkTypes = async () => {
			const response = await api.get(config.api + '?method=workTypes');
			const mappedOptions = response.data.map(item => ({
				value: item.id,
				label: item.name,
				operation_type: item.operation_type,
				without_service_invoice: item.without_service_invoice,
			}));
			setWorkTypesOptions(mappedOptions);
			// select first one by default
			if (mappedOptions.length > 0 && !selectedWorkType)
			{
				setSelectedWorkType(mappedOptions[0].value);
			}
		};
		fetchWorkTypes();

		const fetchServiceEmployee = async () => {
			const response = await api.get(config.api + '?method=ServiceEmployee');
			const mappedOptions = [];
			const seenIds = new Set();
			(Array.isArray(response.data) ? response.data : []).forEach(item => {
				if (!item?.id || seenIds.has(item.id))
				{
					return;
				}
				seenIds.add(item.id);
				mappedOptions.push({
					value: item.id,
					label: item.name,
					is_franchise_owner: item.is_franchise_owner === true || item.is_franchise_owner === 1 || item.is_franchise_owner === '1',
				});
			});
			setServiceEmployeeOptions(mappedOptions);
			if (mappedOptions.length > 0 && !id)
			{
				const franchiseOwner = mappedOptions.find(option => option.is_franchise_owner);
				setSelectedServiceEmployee(franchiseOwner ? franchiseOwner.value : mappedOptions[0].value);
			}
		};
		fetchServiceEmployee();
	}, []);

	const selectedOption = workType.find(option => option.value === selectedWorkType);
	const isInstallation = selectedOption?.operation_type === 'field_service';

	const selectedServiceEmployeeOption = serviceEmployee.find(option => option.value === selectedServiceEmployee);

	const attachmentRequireCondition = isInstallation && serviceMethod === 'Guarantee';
	
	// Check if parts table columns should be editable based on status (edit mode only)
	const isPartsTableEditable = !id || (id && (status === 'New' || status === 'In_Progress'));
	
	// Check if parts are required for current work type (field_service/installation with Guarantee service method)
	const isPartsRequired = selectedOption?.operation_type && ['field_service', 'installation'].includes(selectedOption.operation_type) && serviceMethod === 'Guarantee' && selectedOption.without_service_invoice !== "1";
	
	// Check if warranty should be disabled due to Non_Guarantee service method (both create and edit mode)
	const isWarrantyDisabledByService = serviceMethod === 'Non_Guarantee';
	// Status Drop down
	const statusOptions = [
		{ value: 'In_Progress', label: 'در حال انجام' },
		{ value: 'On_Hold',     label: 'متوقف'    },
		{ value: 'Completed',   label: 'انجام شده' },
	];

	const attachmentDrop= {
		image: 'فایل ضمیمه',
	}; 
	// Service method drop down
	const serviceOptions = [
		{ value: 'Guarantee', label: 'گارانتی' },
		{ value: 'Non_Guarantee', label: 'غیر گارانتی' },
	];

	// Generate assetLocationOptions from all addresses (including newly added ones)
	const assetLocationOptions = Array.isArray(addresses) ? addresses.map((address, index) => {
		const addressParts = [address.state, address.city, address.street, address.postalcode].filter(part => part && String(part).trim() !== '');
		const addressLabel = addressParts.join(', ');
		const moduleLabel = (address.module === 'Branches' || address.isBranch === 1) ? '(شعبه)' : address.module === 'Accounts' ? '(حساب)' : '';
		const uniqueValue = address.id || `temp-${index}`;
		return {
			label: addressLabel + (moduleLabel ? ` ${moduleLabel}` : ''),
			value: uniqueValue,
		};
	}) : [];

	return <>
		<div className='title flex justify-between w-full'>
			<h6>ایجاد دستورکار</h6>
			<div className="flex">
				<button onClick={() => navigate('/list/Work_Orders')}  type="button" className='btn btn-secondary' >
					{language.CANCEL}
				</button>
				<button onClick={DoSave} type="button" className='btn btn-primary'>
					{language.SAVE}
				</button>
			</div>
		</div>
		<div className="flex flex-wrap">
			{id && (
				<div className="Field_Container">
					<div className="flex">
						<label>
							شماره دستورکار
						</label>
					</div>
					<input
						type="text"
						className="form-control"
						value={workOrderNumber}
						disabled
					/>
				</div>
			)}
			<div className="Field_Container">
				<div className="flex">
					<label>
						نوع کار <span className="text-danger">*</span>
					</label>
				</div>
				<Select
					options={workType.map(option => ({
						...option,
						isDisabled: hasInstallationWorkOrder && option.operation_type === 'installation'
					}))}
					value={workType.find(option => option.value === selectedWorkType)}
					onChange={handleWorkTypeChange}
					inputId="type-select"
					className="vision-select-container"
					classNamePrefix="vision-select"
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>
						شماره سریال دستگاه <span className="text-danger">*</span>
					</label>
				</div>
				<input
					type="text"
					className="form-control"
					value={assetSerialNumber}
					onChange={(e) => {
						const value = e.target.value;
						SetAssetSerialNumber(value);
						
						// Clear fields when serial number is empty
						if (value.length === 0) {
							SetAddress([]);
							SetAccount('');
							SetDataEntry([]);
							setSelectAssetLocation(null);
							SetAssetRefrenceNumber('');
							setDisabledFields({
								assetRefrenceNumber: false,
								account: false,
								assetSerialNumber: false,
								warranty: false
							});
							setWarrantyDetails(null);
							SetaosProductSearchResult([]);
							setAddressKey(prev => prev + 1); // Force Addresses component to re-render
							setHasInstallationWorkOrder(false); // Reset installation work order flag
						}
					}}
					onBlur={(e) => handleSerialNumber(e.target.value)}
					disabled={disabledFields.assetSerialNumber}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
				<label>
					شناسه رهگیری {isInstallation && <span className="text-danger">*</span>}
				</label>
				</div>
				<input
					type="text"
					className="form-control"
					value={assetRefrenceNumber}
					onChange={(e) => SetAssetRefrenceNumber(e.target.value)}
					onBlur={(e) => handleDuplicateRefrenceNumber(e.target.value)}
					disabled={disabledFields.assetRefrenceNumber}
					maxLength={13}
					required={isInstallation}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>
						مشتری<span className="text-danger">*</span>
					</label>
				</div>
				<input
					type="text"
					className="form-control"
					onChange={(e) => SetAccount(e.target.value)}
					onClick={(e) => setShowModal(true)}
					value={account}
					disabled={account !== ''}
				/>
			</div>
			<Modal
				handler={<></>}
				trigger={showModal}
				fallDown={hideModal}
				onClose={() => {
					setShowModal(false);
					if ((!account || account.length === 0) && !dataEntry?.[0]?.id) 
					{
						SetDataEntry([]);
					}
					setPhoneNumber('');
					SetNationalNumber('');
					SetNotFoundEntry(false);
				}}
				title="جستجو مشتری"
			>
				<div className="flex flex-wrap">
					<div className="Field_Container">
						<div className="flex">
							<label>
								شماره تماس<span className="text-danger">*</span>
							</label>
						</div>
						<input
							type="text"
							className="form-control"
							onChange={(e) => {
								const value = e.target.value;
								setPhoneNumber(value);
								if (value.length === 0 && nationalNumber.length === 0) 
								{
									if (!account || account.length === 0)
									{
										SetDataEntry([]);
									}
									SetNotFoundEntry(false);
								}
							}}
							onBlur={(e) => handleSearchByPhone(e.target.value)}
							value={phoneNumber}
						/>
					</div>
					<div className="Field_Container">
						<div className="flex">
							<label>
								کدملی<span className="text-danger">*</span>
							</label>
						</div>
						<input
							type="text"
							className="form-control"
							onChange={(e) => {
								const value = e.target.value;
								SetNationalNumber(value);
								if (value.length === 0 && phoneNumber.length === 0) 
								{
									if (!account || account.length === 0) 
									{
										SetDataEntry([]);
									}
									SetNotFoundEntry(false);
								}
							}}
							onBlur={(e) => handleSearchByNationalNumber(e.target.value)}
							value={nationalNumber}
						/>
					</div>
					{dataEntry?.length > 0 && dataEntry[0]?.method != 'checkSerialNumber' ? (
						<table className="w-full border border-gray-300">
							<thead>
								<tr className="bg-gray-200">
									<th className="border p-2">شماره تماس</th>
									<th className="border p-2">نام</th>
									<th className="border p-2">عملیات</th>
								</tr>
							</thead>
							<tbody>
								{dataEntry.map((item, index) => (
									<tr key={item.id} className="border">
										<td className="border p-2">{item.phone_number}</td>
										<td className="border p-2">{item.name}</td>
										<td className="border p-2">
											<button onClick={() => FillInputes(index)} className="btn-primary">
												انتخاب
											</button>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					) : notFoundEntry ? (
						<button 
							type="button"
							onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); newCustomer(); }}
							onClick={(e) => e.preventDefault()}
							className="btn btn-primary"
						>
							ایجاد مشتری جدید
						</button>
					) : null}
				</div>
			</Modal>
			<Modal
				handler={<></>}
				trigger={showWarrantyDetailsModal}
				fallDown={false}
				onClose={() => setShowWarrantyDetailsModal(false)}
				title="جزیات وارانتی"
			>
				<div className="flex flex-wrap">
					<div className="Field_Container">
						<div className="flex">
							<label>
								پوشش انجام کار
							</label>
						</div>
						<input
							type="text"
							className="form-control"
							value={warrantyDetails?.labor_covered_label || ''}
							readOnly
						/>
					</div>
					<div className="Field_Container">
						<div className="flex">
							<label>
								تاریخ انقضا پوشش انجام کار
							</label>
						</div>
						<input
							type="text"
							className="form-control"
							value={warrantyDetails?.labor_expire_date || ''}
							readOnly
						/>
					</div>
					<div className="Field_Container">
						<div className="flex">
							<label>
								پوشش قطعات
							</label>
						</div>
						<input
							type="text"
							className="form-control"
							value={warrantyDetails?.part_covered_label || ''}
							readOnly
						/>
					</div>
					<div className="Field_Container">
						<div className="flex">
							<label>
								تاریخ انقضا پوشش قطعات
							</label>
						</div>
						<input
							type="text"
							className="form-control"
							value={warrantyDetails?.part_expire_date || ''}
							readOnly
						/>
					</div>
					<div className="Field_Container">
						<div className="flex">
							<label>
								پوشش هزینه ها
							</label>
						</div>
						<input
							type="text"
							className="form-control"
							value={warrantyDetails?.expenses_covered_label || ''}
							readOnly
						/>
					</div>
					<div className="Field_Container">
						<div className="flex">
							<label>
								تاریخ انقضا پوشش هزینه ها
							</label>
						</div>
						<input
							type="text"
							className="form-control"
							value={warrantyDetails?.expenses_expire_date || ''}
							readOnly
						/>
					</div>
				</div>
			</Modal>
			<div className="Field_Container">
				<div className="">
					<label>وارانتی</label>
				</div>
				<div className="flex items-center gap-2">
					<div className="form-check form-switch">
						<input
							type="checkbox"
							className="form-control"
							onChange={(e) => SetWarranty(e.target.value)}
							value={warranty}
							disabled
							checked = {disabledFields.warranty}
						/>
					</div>
					{disabledFields.warranty && warrantyDetails && (
						<button 
							type="button" 
							className="btn btn-secondary btn-sm"
							onClick={() => setShowWarrantyDetailsModal(true)}
						>
							جزیات وارانتی
						</button>
					)}
				</div>
			</div>
			{account && account.length > 0 && (
				<div className="Field_Container">
					<div className="flex">
						<label>آدرس<span className="text-danger">*</span></label>
					</div>
					{/* Only set defaultValue from addresses state, not from dataEntry[0]?.addresses */}
					<Addresses
						key={addressKey}
						onChange={(value) => HandleAddress(value)}
						defaultValue={Array.isArray(addresses) ? [...addresses] : []}
					/>
				</div>
			)}
			<div className="Field_Container">
				<div className="flex">
					<label>
						نحوه سرویس <span className="text-danger">*</span>
					</label>
				</div>
				<Select
					options={serviceOptions}
					value={serviceOptions.find(option => option.value === serviceMethod)}
					onChange={(selectedOption) => SetServiceMethod(selectedOption.value)}
					inputId="type-select"
					className="vision-select-container"
					classNamePrefix="vision-select"
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>
						وضعیت <span className="text-danger">*</span>
					</label>
				</div>
			<Select
				options={statusOptions}
				value={statusOptions.find(opt => opt.value === status)}
				onChange={opt => SetStatus(opt.value)}
				inputId="type-select"
				className="vision-select-container"
				classNamePrefix="vision-select"
				isDisabled={originalStatus === 'Completed'}
			/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>
						تاریخ انجام کار <span className="text-danger">*</span>
					</label>
				</div>
				<DatePicker
					value={date}
					onChange={(dateObj) =>	SetDate(dateObj?.format("YYYY/MM/DD"))}
					calendar={preferences.language === 'en_US' ? null : persian}
					locale={preferences.language === 'en_US' ? null : persian_fa}
					inputClass="date-picker"
					containerClassName="w-full"
					arrow={false}
					calendarPosition="bottom-right"
					hideOnScroll
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>
						 ضمیمه {attachmentRequireCondition && <span className="text-danger">*</span>}
					</label>
				</div>
				<Attachments  types={attachmentDrop} single={false} onChange={(value) => HandleAttachment(value)}></Attachments>
				{attachments?.length > 0 && id && (
					<table className="w-full border border-gray-300 mt-2">
						<thead>
							<tr className="bg-gray-200">
								<th className="border p-2">نام فایل</th>
								<th className="border p-2">عملیات</th>
							</tr>
						</thead>
						<tbody>
							{attachments.map((attachment, index) => (
								<tr key={attachment.id || index}>
									<td className="border p-2">{attachment.document_name}</td>
									<td className="border p-2">
										<button
											onClick={() => {
												const fileID = `${attachment.attachment}`;
												DownloadFileAPI(fileID).then((response) => {
													if (response?.content) {
														DownloadByContent(response.content, response.name);
													}
												});
											}}
											className="btn secondary"
										>
											دانلود
										</button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				)}
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>توضیحات</label>
				</div>
				<textarea value={description || ''} onChange={(e) => SetDescription(e.target.value)} rows="1" className="!transition-none !delay-0"></textarea>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>
						محل دستگاه <span className="text-danger">*</span>
					</label>
				</div>
				<Select
					options={assetLocationOptions}
					onChange={handleSelectAddress}
					value={assetLocationOptions.find(opt => {
						if (assetLocation && assetLocation.id) {
							return opt.value === assetLocation.id;
						}
						// For temp addresses, find by index
						if (opt.value.startsWith('temp-')) {
							const index = parseInt(opt.value.split('-')[1]);
							return addresses[index] === assetLocation;
						}
						return false;
					}) || null}
					inputId="type-select"
					className="vision-select-container"
					classNamePrefix="vision-select"
					styles={{
						option: (base) => ({ ...base, whiteSpace: 'normal' }),
						singleValue: (base) => ({ ...base, whiteSpace: 'normal' }),
					}}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>
						کارمند سرویس <span className="text-danger">*</span>
					</label>
				</div>
				<Select
					options={serviceEmployee}
					value={serviceEmployee.find(option => option.value === selectedServiceEmployee)}
					onChange={(selectedServiceEmployeeOption) => setSelectedServiceEmployee(selectedServiceEmployeeOption.value)}
					inputId="type-select"
					className="vision-select-container"
					classNamePrefix="vision-select"
				/>
			</div>
			<div className="Field_Container"></div>
				<Modal
					handler={<></>}
					trigger={showAosProductModal}
					fallDown={hideAosProductModal}
					onClose={() => setAosProductModal(false)}
					title="جستجو محصولات"
				>
				<div className="flex">
					<label>
						نام یا کد محصول
					</label>
				</div>
				<input
					placeholder="حداقل سه کاراکتر وارد کنید ..."
					type="text"
					className="form-control mb-4"
					value={aosProductSearch || ''}
					onChange={(e) => handleLiveSearch(e.target.value)}
				/>
				<div class="max-h-[350px]">
					<table className="w-full border border-gray-300">
						<thead>
							<tr className="bg-gray-200">
								<th className="border p-2">نام اجرت و قطعه</th>
								<th className="border p-2">کد مشخصات فنی</th>
								<th className="border p-2">کد محصول</th>
								<th className="border p-2">عملیات</th>
							</tr>
						</thead>
						<tbody>
							{Array.isArray(aosProductSearchResult) ? (
								aosProductSearchResult.map((item, index) => (
									<tr key={item.id} className="border">
										<td className="border p-2">{item.name}</td>
										<td className="border p-2">{item.properties_as}</td>
										<td className="border p-2">{item.part_number}</td>
										<td className="border p-2">
											<button onClick={() => selectPartAos(index)} className="btn-primary">
													انتخاب
											</button>
										</td>
									</tr>
								))
							) : (
								''
							)}
						</tbody>
					</table>
				</div>
				</Modal>
			<div className="Field_Container">
				<div className="flex">
					<button onClick={(e) => setAosProductModal(true)} type="button" className='btn btn-primary'>
							افزودن اجرت و قطعه {isPartsRequired && <span className="text-danger">*</span>}
					</button>
					<button onClick={CalculatePolicies} type="button" className='btn btn-primary'>
							برآورد قیمت
					</button>
				</div>
				{isPartsRequired && (
					<div className="text-sm text-gray-600 mt-2">
						برای نوع کار انتخاب شده، انتخاب حداقل یک اجرت و قطعه الزامی است
					</div>
				)}
			</div>
			{showPartsTable && (
				<div className="w-full">
					<table className="w-full border border-gray-300 mt-4">
						<thead>
							<tr className="bg-gray-200">
								<th className="border p-2">نام اجرت و قطعه</th>
								<th className="border p-2">کد محصول</th>
								<th className="border p-2">کد مشخصلات فنی</th>
								<th className="border p-2">تعداد</th>
								<th className="border p-2">قیمت مصرف کننده</th>
								<th className="border p-2">قیمت نمایندگی</th>
								<th className="border p-2">گارانتی</th>
								<th className="border p-2">عملیات</th>
							</tr>
						</thead>
						<tbody>
						{selectedParts.filter(item => !item.isDeleted).map((item, idx) => {
							return (
								<tr key={item.id}>
									<td className="border p-2">{item.name}</td>
									<td className="border p-2">{item.part_number}</td>
									<td className="border p-2">{item.properties_as || '-'}</td>
									<td className="border p-2">
									<input
										type="number"
										className={`border w-16 p-1 ${!isPartsTableEditable ? 'bg-gray-100 cursor-not-allowed' : ''}`}
										value={item.count}
										min={1}
										disabled={!isPartsTableEditable}
										onChange={(e) => {
										if (!isPartsTableEditable) return;
										const value = parseInt(e.target.value) || 1;
										setSelectedParts(prev =>
										prev.map((p) =>
											p.id === item.id ? { ...p, count: value } : p
										)
										);
										}}
									/>
									</td>
									<td className="border p-2">{item.consumerPrice != null && item.consumerPrice !== '' ? formatPrice(item.consumerPrice) : (item.type === 'Service' ? '----' : '')}</td>
									<td className="border p-2">{item.partnerPrice != null && item.partnerPrice !== '' ? formatPrice(item.partnerPrice) : (item.type === 'Service' ? '----' : '')}</td>
									<td className="border p-2">
									<input
										type="checkbox"
										// checked={isWarrantyDisabledByService ? false : (item.under_warranty === "1" || item.checked)}
										checked={ isWarrantyDisabledByService ? false : item.under_warranty === "1" ? true : item.checked }
										disabled={!isPartsTableEditable || isWarrantyDisabledByService || status === 'Completed'}
										className={(!isPartsTableEditable || isWarrantyDisabledByService || status === 'Completed') ? 'cursor-not-allowed' : ''}
										onChange={(e) => {
										if (!isPartsTableEditable || isWarrantyDisabledByService || status === 'Completed') return;
										const checked = e.target.checked;
										setSelectedParts(prev =>
										prev.map(p =>
											p.id === item.id ? { ...p, checked } : p
										)
										);
										}}
									/>
									</td>
									<td className="border p-2">
									<button
										onClick={() => {
										if (!isPartsTableEditable && !(item.type === 'Service' && status === 'In_Progress')) return;
										
										// In edit mode, track deleted parts instead of removing them
										if (id && item.isExisting) {
											setDeletedParts(prev => [...prev, item.id]);
											setSelectedParts(prev => prev.map(p => 
												p.id === item.id ? { ...p, isDeleted: true } : p
											));
										} else {
											// In create mode, remove from array
											setSelectedParts(prev => prev.filter(p => p.id !== item.id));
										}
										}}
										className={`hover:underline ${
										(!isPartsTableEditable && !(item.type === 'Service' && status === 'In_Progress')) || (item.isExisting && workOrderId && item.type !== 'Service') 
										? 'text-gray-400 cursor-not-allowed' 
										: 'text-red-500'
										}`}
										disabled={(!isPartsTableEditable && !(item.type === 'Service' && status === 'In_Progress')) || !!(item.isExisting && workOrderId && item.type !== 'Service')}
									>
										حذف
									</button>
									</td>
								</tr>
							);
						})}

						</tbody>
					</table>
					{!(selectedOption?.operation_type === 'installation' && !id) && (
						<button onClick={() => DoSave("productRequest")} type="button" className="btn btn-secondary mt-6">
							ثبت و ایجاد درخواست کالا
						</button>
					)}
				</div>
			)}
		</div>
	</>
}
export default CreateWork_Orders;